export default __webpack_public_path__ + "static/media/up-logo.5fbc334d.png";